"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bchaddrjs_1 = __importDefault(require("bchaddrjs"));
const address_1 = require("bitcoinjs-lib/src/address");
const errors_1 = require("@ledgerhq/errors");
const base_1 = __importDefault(require("./base"));
// a mock explorer class that just use js objects
class BitcoinCash extends base_1.default {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor({ network }) {
        super({ network });
        this.network = network;
        this.network.dustThreshold = 5430;
        this.network.dustPolicy = "FIXED";
        this.network.usesTimestampedTransaction = false;
    }
    getLegacyBitcoinCashAddress(xpub, account, index) {
        const _super = Object.create(null, {
            getLegacyAddress: { get: () => super.getLegacyAddress }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return bchaddrjs_1.default.toCashAddress(yield _super.getLegacyAddress.call(this, xpub, account, index));
        });
    }
    // get address given an address type
    customGetAddress(derivationMode, xpub, account, index) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getLegacyBitcoinCashAddress(xpub, account, index);
        });
    }
    toOutputScript(address) {
        if (!this.validateAddress(address)) {
            throw new errors_1.InvalidAddress();
        }
        // TODO find a better way to calculate the script from bch address instead of converting to bitcoin address
        return (0, address_1.toOutputScript)(bchaddrjs_1.default.toLegacyAddress(address), this.network);
    }
    validateAddress(address) {
        return bchaddrjs_1.default.isValidAddress(address);
    }
}
exports.default = BitcoinCash;
//# sourceMappingURL=bitcoincash.js.map